import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Parser } from 'expr-eval';
import { DailyReportService } from '../../../../daily-report.service';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';
import * as moment from 'moment';
import { ProjectsService } from '../../../../../../../../core/projects.service';
import * as $ from 'jquery';
import { AppService } from '../../../../../../../../../../shared/services';
import { currentLocation, dailyReport, projectDetails, siteDetails } from '../../../../../../../../core/projects.selectors';
import { DeleteVideoFromMuxDbRequest } from '../../../../../../../../core/projects.actions';
import { Ability, subject } from '@casl/ability';
import { MapService } from '../../../../../../../../../../shared/services/map.service';
import { BidService } from '../../../../../../../../../../shared/services/bid.service';
import { formatVolumeLabel, isVolumeFeature } from '../../../../../../../../../../shared/helpers/volume-geometry';
import { VolumeViewerDialogComponent } from '../../../../../../../../../../shared/components/volume-viewer-3d/volume-viewer-dialog.component';
import { LocationPickerLauncherService } from '../../../../../../../../../../shared/services/location-picker-launcher.service';
import { PickTarget } from '../../../../../../../../../../shared/helpers/design-context-pick';
import {
  clearLocationControls,
  currentMapFeatureLink,
  hasRecordLocation,
  linkCaptureImage,
  rebuildKeepingLinkRemovals,
  removeLinkControl,
} from '../../../../../../../../../../shared/helpers/design-context';
import { MapFeatureLink } from '../../../../../../../../../../shared/models/map-feature-link';
import { ItemPostingsStationPopupComponent } from '../../item-postings/item-postings-station-popup/item-postings-station-popup.component';
import { appDataDetails } from '../../../../../../../../../../shared/core/shared.selectors';
import { dropLinkWithConfirm } from '../../../../../../../../../../shared/helpers/link-removal';

@Component({
    selector: 'app-multiline-bid-item-details',
    templateUrl: './multiline-bid-item-details.component.html',
    styleUrls: ['../../input-component-styles.scss', './multiline-bid-item-details.component.scss'],
    standalone: false
})
export class MultilineBidItemDetailsComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() lineItems: any[];
  @Input() bidItem: any;
  @Input() disabled = false;
  @Input() clickId?: string;
  selectedLineItem;

  quantityTotal: unknown = null;
  savedQuantityTotal = 0;
  siteQuantities: any[] = [];
  form: FormGroup = new FormGroup({});
  formSubscription: Subscription = new Subscription();
  isFormReady = false;
  autoCalculateOptions = [
    {
      label: 'Auto calculate',
      value: 'dynamic_rollup',
    },
    {
      label: 'Enter manually',
      value: 'manual_entry',
    },
  ];
  selectedLineItemId = '';
  /** The line item that opened the pin picker: its pick lands there even if the selection moved while the picker was opening. */
  private readonly pickTarget = new PickTarget();
  selectedLineItemMediaFiles = [];
  videoToBeDeletedFromMuxDb = [];

  lineItemTotals: any = {};

  calculatedValues: any = {};
  project: any = null;
  projectId: string | null = null;
  appData: any = null;

  gpsQuantityOptionsMap: { [key: string]: { value: string, label: string }[] } = {};
  hoveredGpsFeatureKey: string | null = null; // lineItemId_featureIndex
  selectedGpsFeatureKey: string | null = null; // lineItemId_featureIndex (persistent click-to-select)
  @Input() showMiniMaps = true;
  @Input() highlightFeatureIndex: number | null = null;
  /** When true (map drilldown mode), accordion gets the expanded highlight and
   *  hover syncs with the map. In plain daily-report mode this is false. */
  @Input() mapMode = false;

  // Cached GPS data to avoid repeated method calls in template
  cachedGpsFeatures: Map<string, any[]> = new Map();
  cachedGpsFlags: Map<string, boolean> = new Map();
  stationRangeDisplayByLineItemId: { [lineItemId: string]: any } = {};
  private parsedAlignmentGeometry: any[] = [];

  // Line item id currently hovered (from either sidepanel or map) — drives two-way highlight
  hoveredLineItemId: string | null = null;

  formSubscriptions: any[] = [];
  dailyReport: any;
  editable: any;

  private readonly onDestroy: Subject<any> = new Subject<any>();
  private readonly injector = inject(Injector);
  private readonly elementRef = inject(ElementRef);

  constructor(
    private store: Store<fromRoot.State>,
    private fb: FormBuilder,
    private dailyReportService: DailyReportService,
    private commonService: CommonService,
    private projectsService: ProjectsService,
    private dialog: MatDialog,
    protected appService: AppService,
    protected ability: Ability,
    private mapService: MapService,
    private cdr: ChangeDetectorRef,
    private locationPickerLauncher: LocationPickerLauncherService,
  ) {
    this.dailyReportService.add
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.form) {
          this.store.select(dailyReport)
            .subscribe((report) => {
              const details = report.reportDetails;

              if (details) {
                const { bidItems } = details;

                const selectedElement = bidItems.find((o) => this.bidItem.id === o.bidItem.id);

                if (selectedElement) {
                  this.bidItem = selectedElement.bidItem;
                  this.lineItems = JSON.parse(JSON.stringify(selectedElement.lineItems));
                }
              }
            });


          const id = `new_${new Date().getTime()}`;
          this.selectedLineItemId = id;
          this.dailyReportService.disableAddMenu.next(false);

          const newElement = {
            id,
            bid_item_id: this.bidItem.id,
            created_at: moment().toISOString(),
            bid_item: this.bidItem,
            quantity: null,
            comment: '',
            station_id: null,
            latitude: '',
            longitude: '',
            location: null,
            station_range: null,
            heading_id: null,
            start_of_work: false,
            station_break: false,
            updated_at: null,
            pictures: [],
            videos: [],
            station: null,
            heading: null,
            annotations: [],
            sources: [],
            ...(this.bidItem.rollup ?
              {
                field_values: this.bidItem?.fields?.map(o => ({
                    id: o.id,
                    value: null,
                  }),
                ),
              } : {}),

          };

          this.addNewLineItem(newElement);
        }

      });
  }

  ngAfterViewInit(): void {
    // Auto-select/highlight is now handled in ngOnChanges to support
    // both initial load and subsequent geometry clicks
  }

  ngOnInit() {
    this.store.select(projectDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(project => {
        this.project = project;
        this.projectId = project?.id ?? null;
        this.parsedAlignmentGeometry = this.parseAlignmentGeometry(
          this.project?.alignment_geometry || this.project?.alignmentGeometry,
        );
        this.updateStationRangeDisplayCache();
        this.cdr.detectChanges();
      });

    this.store.select(appDataDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(appData => {
        this.appData = appData;
      });

    // Two-way hover sync: when map hovers a geometry, highlight the matching accordion
    this.mapService.hoveredLineItemId
      .pipe(takeUntil(this.onDestroy))
      .subscribe(id => {
        this.hoveredLineItemId = id;
        this.cdr.detectChanges();
      });

    // Map mode: a click on empty map collapses the open line, which ends the fade
    this.mapService.collapseOpenLine
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (!this.mapMode || !this.selectedLineItemId) return;
        this.selectLineItem(this.selectedLineItemId);
        this.clearGpsFeatureSelection();
        this.cdr.detectChanges();
      });

    this.commonService.uploadedFilesInfo
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        const items = Array.isArray(data) ? data : [data];
        const formGroup = this.getFormGroup(this.form, this.selectedLineItemId);

        items.forEach(eachItem => {
          if (eachItem?.['fileType'] === 'picture' || eachItem?.['fileType'] === 'document') {
            let pictures = formGroup?.get('pictures')?.value || '[]';
            pictures = JSON.parse(pictures);
            pictures.push(eachItem);
            formGroup?.get('pictures')?.setValue(JSON.stringify(pictures));
          }

          if (eachItem?.['fileType'] === 'video') {
            let videos = formGroup?.get('videos')?.value || '[]';
            videos = JSON.parse(videos);
            videos.push(eachItem);
            formGroup?.get('videos')?.setValue(JSON.stringify(videos));
          }
        });

        const tempPictureData = this.getSelectedLineItemPictures() ?? [];
        const tempVideosData = this.getSelectedLineItemVideos() ?? [];
        const allNewItems = [...tempPictureData, ...tempVideosData];

        allNewItems.forEach(item => {
          const existingItem = this.selectedLineItemMediaFiles.find(ei => ei.id === item.id);

          if (!existingItem) {
            this.selectedLineItemMediaFiles.push(item);
          }
        });

        this.selectedLineItemMediaFiles = [...this.selectedLineItemMediaFiles];
      });

    this.dailyReportService.addComment
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.form) {
          const tempControl = this.getFormGroup(this.form, this.selectedLineItemId).get('comment');

          if (!tempControl) {
            this.getFormGroup(this.form, this.selectedLineItemId)?.addControl('comment', new FormControl(null));

            setTimeout(() => {
              $(`#${this.selectedLineItemId} textarea`).focus();
            }, 100);
          }
        }
      });

    this.dailyReportService.triggerSave
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.form) {
          this.dailyReportService.formatAndSaveMultilineBidItemPayload(this.form, this.bidItem, this.lineItems);
        }
        if (this.videoToBeDeletedFromMuxDb.length) {
          this.videoToBeDeletedFromMuxDb.forEach(videoId => {
            this.store.dispatch(DeleteVideoFromMuxDbRequest({ payload: videoId }));
          });
        }
      });

    this.dailyReportService.triggerDelete
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.bidItem) {
          this.dailyReportService.delete.next({
            type: 'bidItems',
            id: this.bidItem.id,
          });
        }
      });

    this.dailyReportService.selectedLocation
      .pipe(takeUntil(this.onDestroy))
      .subscribe((location) => {
        if (this.form) {
          const lineItemId = this.pickTarget.resolve(this.selectedLineItemId);
          const formGroup = this.getFormGroup(this.form, lineItemId);
          formGroup?.patchValue(location);
          // A pick that carries the link (new, or null after Remove) changed it in this session (R54)
          if (location && typeof location === 'object' && 'map_feature_link' in location) {
            formGroup?.get('map_feature_link')?.markAsDirty();
          }
          if (location?.locationText !== undefined) {
            formGroup?.controls?.location?.setValue(location.locationText);
          }
          if (location?.station_range) {
            this.applyStationRangeToForm(lineItemId, location.station_range);
          }
          this.updateStationRangeDisplayCache();
          this.publishLocationStationToolbarState();
        }
      });

    this.dailyReportService.setStationRange
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data?.form) return;
        if (!this.selectedLineItemId) return;
        const { stationRange, alignment } = data || {};
        this.applyStationRangeToForm(this.selectedLineItemId, {
          ...stationRange,
          alignment,
        });
      });

    this.store.select(dailyReport)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((report: any) => {
        this.dailyReport = { ...report };
        this.editable = this.ability.can('create', subject('DailyReport', this.dailyReport));
        // Only override disabled if not explicitly set by parent (e.g., map sidenav always passes disabled: true)
        if (!this.disabled) {
          this.disabled = !this.editable;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {

    this.formSubscriptions.map(o => o?.unsubscribe());
    this.formSubscriptions = [];

    this.dailyReportService.disableAddMenu.next(true);
    this.projectsService.isAnyFormDirty.next(false);
    this.formSubscription?.unsubscribe();

    this.isFormReady = false;

    // Precompute GPS flags and features caches for template performance
    this.refreshGpsCaches();

    if (this.lineItems && this.lineItems.length > 0) {
      this.form = this.createLineItemForm(this.bidItem, this.lineItems);
      this.calculateLineItemQuantity();
      this.savedQuantityTotal = Number(this.quantityTotal) || 0;
    } else {
      this.dailyReportService.add.next();
    }

    // Fetch site quantities for consumption info
    if (this.bidItem?.id) {
      this.projectsService.fetchBidItemsSitesList({
        bidItemId: this.bidItem.id,
        qp: { include: ['site_quantities'] },
      }).pipe(takeUntil(this.onDestroy)).subscribe((response: any) => {
        this.siteQuantities = response?.data?.site_quantities || [];
      });
    }

    if (this.disabled) {
      this.form.disable();
      this.projectsService.isAnyFormDirty.next(false);
    }
    this.isFormReady = true;

    // Auto-select and highlight line item when clickId or highlightFeatureIndex changes (geometry click on map)
    if (this.clickId !== undefined && this.clickId !== null) {
      setTimeout(() => {
        // Force-open (not toggle) the specified line item accordion
        this.selectedLineItemId = this.clickId;
        this.publishOpenLineItem();
        this.selectedLineItemMediaFiles = [];
        const pictures = this.getSelectedLineItemPictures() ?? [];
        const videos = this.getSelectedLineItemVideos() ?? [];
        this.selectedLineItemMediaFiles = [...pictures, ...videos];
        this.dailyReportService.disableAddMenu.next(false);

        if (this.highlightFeatureIndex !== null && this.highlightFeatureIndex !== undefined) {
          // Set persistent selection (not just hover) for the clicked geometry
          this.selectedGpsFeatureKey = `${this.clickId}_${this.highlightFeatureIndex}`;
          this.mapService.selectedGpsLineItemId.next(this.clickId);
          this.mapService.selectedGpsFeatureIndex.next(this.highlightFeatureIndex);
        } else {
          // Clear any previous selection when no feature specified
          this.clearGpsFeatureSelection();
        }

        if (this.mapMode) {
          this.scrollToLineItem(this.clickId);
        }
      }, 100);
    } else {
      // Re-enable add menu if a line item is already selected (e.g. opened via clickId)
      // For GPS geometry items, auto-select the first line item so + button works immediately
      if (!this.selectedLineItemId && this.lineItems?.length) {
        const firstGps = this.lineItems.find(li => this.hasGpsGeometry(li));
        if (firstGps) {
          this.selectedLineItemId = firstGps.id;
          this.publishOpenLineItem();
          // The pictures section only renders from this list, so load it with the selection.
          const pictures = this.getSelectedLineItemPictures() ?? [];
          const videos = this.getSelectedLineItemVideos() ?? [];
          this.selectedLineItemMediaFiles = [...pictures, ...videos];
        }
      }
      if (this.selectedLineItemId) {
        this.dailyReportService.disableAddMenu.next(false);
      }
    }
  }

  calculateLineItemQuantity(controlName = null) {
    if (controlName) {
      this.lineItemTotals = {
        ...this.lineItemTotals,
        [controlName]: 0,
      };
      this.calculateQuantity(controlName);
    } else {
      this.lineItemTotals = {};
      Object.keys(this.form.controls).forEach(c => {
        this.calculateQuantity(c);
      });
    }

    this.calculateTotalQuantity();
  }

  calculateQuantity(controlName) {
    const parentName = !controlName.includes('new') ? controlName.split('_')[0] : controlName;
    const parent = this.form.controls[parentName];

    // GPS geometry items - handle based on quantity mode
    const gpsLineItem = this.lineItems?.find(li => li.id === parentName);
    if (gpsLineItem && this.hasGpsGeometry(gpsLineItem)) {
      const features = this.getGpsFeatures(gpsLineItem);

      // Persist per-feature field value changes to modified_fields (length_f, width_f, etc.)
      if (this.bidItem.fields?.length) {
        const formValues = parent.getRawValue();
        features.forEach((feature, fi) => {
          const fieldUpdates = {};
          this.bidItem.fields.forEach(field => {
            const val = formValues[`${field.id}_${fi}`];
            if (val !== undefined && val !== null) {
              fieldUpdates[field.name] = Number(val);
              // Also update the feature's modified_fields so calculateGpsAutoQty picks it up
              if (feature.properties?.modified_fields) {
                feature.properties.modified_fields[field.name] = Number(val);
              }
            }
          });
          if (Object.keys(fieldUpdates).length) {
            this.updateGpsModifiedFields(parentName, fi, fieldUpdates);
          }
        });
      }

      if (features.length === 1) {
        const mode = parent?.['controls']?.gpsQuantityMode_0?.value;
        if (mode === 'auto' && this.bidItem.rollup) {
          // Auto mode - use GPS feature's modified_fields (not form field controls)
          const qty = BidService.calculateGpsAutoQty(features[0], this.bidItem);
          parent['controls'].quantity.setValue(qty, { emitEvent: false });
          this.lineItemTotals[parentName] = qty;
          this.updateGpsModifiedFields(parentName, 0, { quantity: qty });
        } else {
          const qty = parent?.['controls']?.quantity?.value;
          this.lineItemTotals[parentName] = isNaN(qty) ? 0 : Number(qty);
          this.updateGpsModifiedFields(parentName, 0, { quantity: Number(qty) || 0 });
        }
      } else {
        // Multiple features - recalculate per-feature for auto mode and sum
        let total = 0;
        features.forEach((feature, i) => {
          const mode = parent?.['controls']?.[`gpsQuantityMode_${i}`]?.value;
          if (mode === 'auto' && this.bidItem.rollup) {
            // Use GPS feature's modified_fields (not form field controls)
            const qty = BidService.calculateGpsAutoQty(feature, this.bidItem);
            parent['controls'][`gpsQuantity_${i}`]?.setValue(qty, { emitEvent: false });
            total += qty;
            this.updateGpsModifiedFields(parentName, i, { quantity: qty });
          } else {
            const featureQty = Number(parent['controls'][`gpsQuantity_${i}`]?.value) || 0;
            total += featureQty;
            this.updateGpsModifiedFields(parentName, i, { quantity: featureQty });
          }
        });
        parent['controls'].quantity.setValue(total, { emitEvent: false });
        this.lineItemTotals[parentName] = total;
      }
      return;
    }


    const parentValueType = parent['controls'].valueType?.value;

    const hasChildren = (Object.keys(this.form.controls).filter(o => o.includes(parentName))).length > 1;

    if (parentName !== controlName || hasChildren) {
      // The totals need to be handled for the parent here

      const childrenControls = Object.keys(this.form.controls).filter(o => o.includes(parentName) && o.includes('_'));

      let groupTotal = 0;
      childrenControls.forEach(childControlName => {
        let qty = 0;
        if (this.bidItem.rollup) {
          qty = this.calculateDynamicRollupValue(this.form.controls[childControlName].getRawValue());
        } else {
          qty = this.form.controls[childControlName]?.['controls'].quantity.value;
        }

        this.form.controls[childControlName]?.['controls'].quantity.setValue(qty, { emitEvent: false });
        qty = isNaN(qty) ? 0 : Number(qty);
        groupTotal += qty;
      });

      if (this.bidItem.rollup) {
        if (parentValueType === 'dynamic_rollup') {
          parent['controls'].quantity.setValue(groupTotal, { emitEvent: false });
          this.lineItemTotals[parentName] = groupTotal;
        } else {
          const qty = parent['controls'].quantity.value;
          this.lineItemTotals[parentName] = isNaN(qty) ? 0 : Number(qty);
        }
        this.calculatedValues[parentName] = groupTotal;
      } else {
        this.lineItemTotals[parentName] = groupTotal;
      }
    } else {
      if (this.bidItem.rollup) {
        if (parentValueType === 'dynamic_rollup') {
          const qty = this.calculateDynamicRollupValue(this.form.controls[controlName].getRawValue());
          parent['controls'].quantity.setValue(qty, { emitEvent: false });
          if (this.lineItemTotals[parentName]) {
            this.lineItemTotals[parentName] += qty;
          } else {
            this.lineItemTotals[parentName] = qty;
          }
        } else {
          const qty = this.form.controls[parentName]?.['controls'].quantity.value;
          this.lineItemTotals[parentName] = isNaN(qty) ? 0 : Number(qty);
        }
      } else {
        const qty = this.form.controls[parentName]?.['controls'].quantity.value;
        this.lineItemTotals[parentName] = isNaN(qty) ? 0 : Number(qty);
      }
    }
  }

  calculateDynamicRollupValue(values) {
    const mapObj = this.getFieldValuesMap(values);
    return Number((Parser.evaluate(this.bidItem.rollup_formula, mapObj)).toFixed(this.bidItem?.quantity_rounding ?? 2));
  }

  getFormGroup(form, controlName) {
    if (form && form.get(controlName)) {
      return form.get(controlName) as FormGroup;
    }

    return new FormGroup({}) as FormGroup;
  }

  getFieldValuesMap(values) {
    const mapObj = {};

    this.bidItem.fields.forEach(field => {
      mapObj[field.name] = Number(values[field.id]);
    });

    return mapObj;
  }

  /**
   * Scroll the line item accordion into view inside the panel's scroll container.
   * Renders first so the previously open accordion has collapsed before measuring.
   */
  private scrollToLineItem(lineItemId: string): void {
    const host: HTMLElement = this.elementRef.nativeElement;
    // The panel may have closed during the selection delay
    if (!host.isConnected) return;
    this.cdr.detectChanges();
    const target = Array.from(host.querySelectorAll<HTMLElement>('[data-line-item-id]'))
      .find(el => el.dataset.lineItemId === String(lineItemId));
    if (!target) return;

    let container = target.parentElement;
    while (container && container !== document.body) {
      const { overflowY } = getComputedStyle(container);
      if ((overflowY === 'auto' || overflowY === 'scroll') && container.scrollHeight > container.clientHeight) {
        break;
      }
      container = container.parentElement;
    }

    if (!container || container === document.body) {
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }

    // Keep the accordion header below the panel's sticky header (bid item title and chips)
    const stickyHeight = Array.from(container.querySelectorAll<HTMLElement>('.detail-view-header'))
      .filter(el => !el.contains(target) && getComputedStyle(el).position === 'sticky')
      .reduce((sum, el) => sum + el.getBoundingClientRect().height, 0);
    const top = container.scrollTop + target.getBoundingClientRect().top - container.getBoundingClientRect().top - stickyHeight;
    container.scrollTo({ top, behavior: 'smooth' });
  }

  /** Map mode: tell the map which line's accordion is open so it can fade the other lines. */
  private publishOpenLineItem(): void {
    if (!this.mapMode) return;
    const openId = this.selectedLineItemId || null;
    if (this.mapService.openLineItemId.getValue() !== openId) {
      this.mapService.openLineItemId.next(openId);
    }
  }

  selectLineItem(lineItemId) {
    this.selectedLineItemId = this.selectedLineItemId === lineItemId ? '' : lineItemId;
    this.publishOpenLineItem();

    // Clear the media files array first to avoid accumulation
    this.selectedLineItemMediaFiles = [];

    const pictures = this.getSelectedLineItemPictures() ?? [];
    const videos = this.getSelectedLineItemVideos() ?? [];
    const allNewItems = [...pictures, ...videos];

    allNewItems.forEach(item => {
      const existingItem = this.selectedLineItemMediaFiles.find(ei => ei.id === item.id);

      if (!existingItem) {
        this.selectedLineItemMediaFiles.push(item);
      }
    });

    if (this.selectedLineItemId) {
      this.dailyReportService.disableAddMenu.next(false);
      this.publishLocationStationToolbarState();
    } else {
      this.dailyReportService.disableAddMenu.next(true);
      this.dailyReportService.locationStationToolbarState = null;
    }
  }

  createLineItemForm(bidItem, lineItems) {
    this.formSubscriptions.map(o => o?.unsubscribe());
    this.formSubscriptions = [];

    const parentFormBuilder = {};

    lineItems?.map(lineItem => {
      let controlName = lineItem.id;
      const isPaid = !!lineItem.pay_app_id; // Determine paid status

      parentFormBuilder[controlName] = this.fb.group({});

      // Disable quantity control if paid
      parentFormBuilder[controlName].addControl('quantity', new FormControl({ value: lineItem.quantity, disabled: isPaid }));

      if (lineItem.comment) {
        parentFormBuilder[controlName].addControl('comment', new FormControl(lineItem.comment)); // Comments remain editable
      }

      parentFormBuilder[controlName].addControl('pictures', new FormControl(JSON.stringify(lineItem.pictures || [])));
      parentFormBuilder[controlName].addControl('videos', new FormControl(JSON.stringify(lineItem.videos || [])));

      parentFormBuilder[controlName].addControl('latitude', new FormControl(lineItem.latitude)); // Location remains editable
      parentFormBuilder[controlName].addControl('longitude', new FormControl(lineItem.longitude)); // Location remains editable
      parentFormBuilder[controlName].addControl('location', new FormControl(lineItem.location || null));
      parentFormBuilder[controlName].addControl('map_feature_link', new FormControl(lineItem.map_feature_link ?? null));
      parentFormBuilder[controlName].addControl('alignment', new FormControl(lineItem.station_range?.alignment || null));
      parentFormBuilder[controlName].addControl('stationRangeFromStation', new FormControl(lineItem.station_range?.from?.station || null));
      parentFormBuilder[controlName].addControl('stationRangeFromOffsetType', new FormControl(lineItem.station_range?.from?.offset_type || null));
      parentFormBuilder[controlName].addControl('stationRangeFromOffsetDistance', new FormControl(lineItem.station_range?.from?.offset_distance || null));
      parentFormBuilder[controlName].addControl('stationRangeToStation', new FormControl(lineItem.station_range?.to?.station || null));
      parentFormBuilder[controlName].addControl('stationRangeToOffsetType', new FormControl(lineItem.station_range?.to?.offset_type || null));
      parentFormBuilder[controlName].addControl('stationRangeToOffsetDistance', new FormControl(lineItem.station_range?.to?.offset_distance || null));

      // GPS geometry quantity controls
      if (this.hasGpsGeometry(lineItem)) {
        const features = this.getGpsFeatures(lineItem);
        let totalGpsQty = 0;

        features.forEach((feature, index) => {
          const mode = this.getInitialGpsQuantityMode(feature);
          // Ensure quantityMode is explicitly set in modified_fields so it persists on save
          if (!feature?.properties?.modified_fields?.quantityMode) {
            this.updateGpsModifiedFields(controlName, index, { quantityMode: mode });
          }
          // For auto mode, always recalculate from modified_fields (not persisted quantity which may be stale)
          // For measured/manual, use persisted quantity or calculate
          let qty;
          if (mode === 'auto') {
            qty = this.calculateGpsAutoQty(feature);
          } else {
            const persistedQty = feature?.properties?.modified_fields?.quantity;
            qty = (persistedQty !== undefined && persistedQty !== null) ? persistedQty : this.getGpsQuantityForMode(feature, mode);
          }
          totalGpsQty += Number(qty) || 0;

          // Build options for this feature's dropdown
          const optionsKey = `${controlName}_${index}`;
          const options = [];
          if (this.featureHasQuantityMapping(feature)) {
            options.push({ value: 'measured', label: 'Measured quantity' });
          }
          options.push(
            { value: 'manual', label: 'Enter manually' },
            { value: 'auto', label: 'Autocalculate' },
          );
          this.gpsQuantityOptionsMap[optionsKey] = options;

          parentFormBuilder[controlName].addControl(`gpsQuantityMode_${index}`, new FormControl(mode));

          if (features.length > 1) {
            parentFormBuilder[controlName].addControl(`gpsQuantity_${index}`, new FormControl(qty));
          }
        });

        // Set total quantity
        parentFormBuilder[controlName].get('quantity')?.setValue(totalGpsQty, { emitEvent: false });
      }

      if (bidItem.rollup === true) {
        lineItem.field_values?.map(field => {
          // Disable field controls if paid
          parentFormBuilder[controlName].addControl(field.id, new FormControl({ value: field.value, disabled: isPaid }));
        });

        // For GPS items, create per-feature field controls (field.id + '_' + featureIndex)
        if (this.hasGpsGeometry(lineItem)) {
          const features = this.getGpsFeatures(lineItem);
          features.forEach((feature, fi) => {
            const modifiedFields = feature?.properties?.modified_fields || {};
            bidItem.fields?.forEach(field => {
              const gpsValue = modifiedFields[field.name] ?? null;
              parentFormBuilder[controlName].addControl(
                `${field.id}_${fi}`,
                new FormControl({ value: gpsValue, disabled: isPaid })
              );
            });
          });
        }

        if (bidItem.rollup_quantity_editable === true) {
          const tempObj = {};
          lineItem.field_values.forEach(field => {
            tempObj[field.id] = field.value;
          });

          const qty = lineItem.quantity;
          let valueTypeValue;
          // If rollup_quantity_manual is explicitly true AND quantity is not 0, show manual
          // This matches mobile behavior where 0 quantity defaults to auto calculate
          if (lineItem.rollup_quantity_manual === true && lineItem.quantity !== 0) {
            valueTypeValue = 'manual_entry';
          } else if (lineItem.rollup_quantity_manual !== true && lineItem.quantity !== null && lineItem.quantity !== 0) {
            // If no explicit flag but has quantity, default to manual
            valueTypeValue = 'manual_entry';
          } else {
            valueTypeValue = 'dynamic_rollup';
          }

          parentFormBuilder[controlName].addControl('initialQuantity', new FormControl(qty)); // Keep initial value
          // Disable valueType dropdown if paid
          parentFormBuilder[controlName].addControl('valueType', new FormControl({ value: valueTypeValue, disabled: isPaid }));
        }
      }

      if (lineItem.sources?.length) {
        lineItem.sourcesSection?.sourcesList?.forEach(source => {
          if (lineItem.sources?.length > 1) {
            controlName = `${lineItem.id}_${source.id}`;
          } else {
            parentFormBuilder[controlName].removeControl('quantity');
            parentFormBuilder[controlName].removeControl('initialQuantity');
            parentFormBuilder[controlName].removeControl('valueType');
          }

          parentFormBuilder[controlName] = this.fb.group({});

          if (lineItem.comment) {
            parentFormBuilder[controlName].addControl('comment', new FormControl(lineItem.comment));
          }

          parentFormBuilder[controlName].addControl('pictures', new FormControl(JSON.stringify(lineItem.pictures || [])));
          parentFormBuilder[controlName].addControl('videos', new FormControl(JSON.stringify(lineItem.videos || [])));

          parentFormBuilder[controlName].addControl('latitude', new FormControl(lineItem.latitude));
          parentFormBuilder[controlName].addControl('longitude', new FormControl(lineItem.longitude));
          parentFormBuilder[controlName].addControl('location', new FormControl(lineItem.location || null));
          parentFormBuilder[controlName].addControl('map_feature_link', new FormControl(lineItem.map_feature_link ?? null));
          parentFormBuilder[controlName].addControl('alignment', new FormControl(lineItem.station_range?.alignment || null));
          parentFormBuilder[controlName].addControl('stationRangeFromStation', new FormControl(lineItem.station_range?.from?.station || null));
          parentFormBuilder[controlName].addControl('stationRangeFromOffsetType', new FormControl(lineItem.station_range?.from?.offset_type || null));
          parentFormBuilder[controlName].addControl('stationRangeFromOffsetDistance', new FormControl(lineItem.station_range?.from?.offset_distance || null));
          parentFormBuilder[controlName].addControl('stationRangeToStation', new FormControl(lineItem.station_range?.to?.station || null));
          parentFormBuilder[controlName].addControl('stationRangeToOffsetType', new FormControl(lineItem.station_range?.to?.offset_type || null));
          parentFormBuilder[controlName].addControl('stationRangeToOffsetDistance', new FormControl(lineItem.station_range?.to?.offset_distance || null));

          parentFormBuilder[controlName].addControl('quantity',
            new FormControl({ value: source.modified_quantity ?? source.source_quantity, disabled: isPaid }),
          );

          if (bidItem.rollup === true) {
            source.fieldValues?.forEach(field => {
              if (field && field.id) {
                parentFormBuilder[controlName].addControl(field.id,
                  new FormControl({ value: field.value, disabled: isPaid }),
                );
              }
            });
            if (bidItem.rollup_quantity_editable === true) {
              let valueTypeValue;
              // Match the same logic as above for consistency
              if (lineItem.rollup_quantity_manual === true && lineItem.quantity !== 0) {
                valueTypeValue = 'manual_entry';
              } else if (lineItem.rollup_quantity_manual !== true && (lineItem.quantity !== null && lineItem.quantity !== 0)) {
                valueTypeValue = 'manual_entry';
              } else {
                valueTypeValue = 'dynamic_rollup';
              }
              const qty = source.modified_quantity ?? source.source_quantity;
              parentFormBuilder[controlName].addControl('initialQuantity', new FormControl(qty));
              parentFormBuilder[controlName].addControl('valueType',
                new FormControl({ value: valueTypeValue, disabled: isPaid }),
              );
            }
          }
        });
      }

    });

    // tslint:disable-next-line:forin
    for (const key in parentFormBuilder) {
      if (!key.includes('_') || key.includes('new')) {
        this.lineItemTotals[key] = parentFormBuilder[key].controls.quantity.value;
      }
    }

    this.calculateTotalQuantity();

    const form = this.fb.group(parentFormBuilder);
    const { controls } = form;
    // @ts-ignore
    // tslint:disable-next-line:prefer-for-of
    for (const controlName in controls) {
      if (controlName) {
        this.formSubscriptions.push(controls[controlName].valueChanges
          .subscribe(o => {
            this.calculateLineItemQuantity(controlName);
            this.updateStationRangeDisplayCache(form);
            if (this.editable) {
              this.projectsService.isAnyFormDirty.next(true);
            }
          }));

        // Add listener for valueType changes to clear quantity when switching to manual
        const valueTypeControl = controls[controlName].get('valueType');
        if (valueTypeControl) {
          this.formSubscriptions.push(
            valueTypeControl.valueChanges.subscribe((newValue) => {
              if (newValue === 'manual_entry') {
                // Clear the quantity when switching to manual entry
                controls[controlName].get('quantity')?.setValue(null, { emitEvent: false });
              }
            }),
          );
        }

        // GPS quantity mode change listeners
        const gpsLineItem = this.lineItems.find(li => li.id === controlName);
        if (gpsLineItem && this.hasGpsGeometry(gpsLineItem)) {
          const features = this.getGpsFeatures(gpsLineItem);
          features.forEach((feature, index) => {
            const modeControl = controls[controlName].get(`gpsQuantityMode_${index}`);
            if (modeControl) {
              this.formSubscriptions.push(
                modeControl.valueChanges.subscribe((mode) => {
                  this.handleGpsQuantityModeChange(controlName, features, feature, index, mode);
                }),
              );
            }

            // Per-feature quantity changes (for multi-feature manual mode)
            if (features.length > 1) {
              const qtyControl = controls[controlName].get(`gpsQuantity_${index}`);
              if (qtyControl) {
                this.formSubscriptions.push(
                  qtyControl.valueChanges.subscribe(() => {
                    this.recalculateGpsTotalQuantity(controlName, features);
                  }),
                );
              }
            }
          });
        }
      }
    }
    this.updateStationRangeDisplayCache(form);
    return form;
  }

  calculateTotalQuantity() {
    this.quantityTotal = Object.values(this.lineItemTotals).reduce((arr, v) => {
      // @ts-ignore
      arr += v;
      return arr;
    }, 0);
  }

  getCurrentStationRange(lineItemId: string) {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    const formValues = formGroup?.getRawValue();
    const lineItem = this.lineItems?.find(item => item.id === lineItemId);
    return this.normalizeStationRange(formGroup
      ? this.buildStationRangeFromValues(formValues)
      : lineItem?.station_range);
  }

  hasLocationOrStation(lineItemId: string) {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    const lineItem = this.lineItems?.find(item => item.id === lineItemId);
    return hasRecordLocation({
      stationRange: this.getCurrentStationRange(lineItemId),
      locationText: formGroup?.controls?.location?.value,
      hasGps: !!(formGroup?.controls?.latitude?.value && formGroup?.controls?.longitude?.value),
      link: currentMapFeatureLink(formGroup, lineItem?.map_feature_link),
    });
  }

  applyStationRangeToForm(lineItemId: string, stationRange: any) {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    if (!formGroup) return;

    formGroup.patchValue({
      alignment: stationRange?.alignment || null,
      stationRangeFromStation: stationRange?.from?.station || null,
      stationRangeFromOffsetType: stationRange?.from?.offsetType ?? stationRange?.from?.offset_type ?? null,
      stationRangeFromOffsetDistance: stationRange?.from?.offsetDistance ?? stationRange?.from?.offset_distance ?? null,
      stationRangeToStation: stationRange?.to?.station || null,
      stationRangeToOffsetType: stationRange?.to?.offsetType ?? stationRange?.to?.offset_type ?? null,
      stationRangeToOffsetDistance: stationRange?.to?.offsetDistance ?? stationRange?.to?.offset_distance ?? null,
    });
    this.updateStationRangeDisplayCache();
    this.publishLocationStationToolbarState(lineItemId);
  }

  private publishLocationStationToolbarState(lineItemId: string = this.selectedLineItemId) {
    if (!lineItemId) {
      this.dailyReportService.locationStationToolbarState = null;
      return;
    }

    const formGroup = this.getFormGroup(this.form, lineItemId);
    this.dailyReportService.locationStationToolbarState = formGroup?.parent ? formGroup.getRawValue() : null;
  }

  private updateStationRangeDisplayCache(form: FormGroup = this.form) {
    const displayByLineItemId = {};

    this.lineItems?.forEach(lineItem => {
      const formGroup = this.getFormGroup(form, lineItem.id);
      const currentStationRange = this.normalizeStationRange(
        formGroup
          ? this.buildStationRangeFromValues(formGroup.getRawValue())
          : lineItem?.station_range,
      );
      const locationText = formGroup?.controls?.location?.value;
      const hasGpsLocation = !!(formGroup?.controls?.latitude?.value && formGroup?.controls?.longitude?.value);
      const locationPoint = this.getLocationPointFromFormGroup(formGroup);
      const mapFeatureLink = currentMapFeatureLink(formGroup, lineItem?.map_feature_link);

      displayByLineItemId[lineItem.id] = {
        currentStationRange,
        locationText,
        // W50: a sheet-only drawing link (no coordinates, station or text) shows the card with its design-context strip
        hasLocationOrStation: hasRecordLocation({ stationRange: currentStationRange, locationText, hasGps: hasGpsLocation, link: mapFeatureLink }),
        stationRangeMapData: this.buildStationRangeMapData(currentStationRange, locationPoint),
        mapFeatureLink,
      };
    });

    this.stationRangeDisplayByLineItemId = displayByLineItemId;
    this.publishLocationStationToolbarState();
  }

  private getLocationPointFromFormGroup(formGroup: FormGroup) {
    const latitudeValue = formGroup?.controls?.latitude?.value;
    const longitudeValue = formGroup?.controls?.longitude?.value;
    if (!this.hasCoordinateValue(latitudeValue) || !this.hasCoordinateValue(longitudeValue)) {
      return null;
    }

    const latitude = Number(latitudeValue);
    const longitude = Number(longitudeValue);
    return Number.isFinite(latitude) && Number.isFinite(longitude)
      ? { lat: latitude, lng: longitude }
      : null;
  }

  private hasCoordinateValue(value: any) {
    return value !== null && value !== undefined && `${value}`.trim() !== '';
  }

  /** Spec addendum §11: the linked capture replaces the station map (`linkCaptureImage`, the card's collapse test). */
  hasCapture(link: MapFeatureLink | null | undefined): boolean {
    return !!linkCaptureImage(link);
  }

  openLocationStationCard(lineItemId: string, stationDisplay: any) {
    if (stationDisplay?.currentStationRange) {
      this.openStationRangePopupForLineItem(lineItemId);
      return;
    }

    this.openLocationPickerForLineItem(lineItemId);
  }

  openStationRangePopupForLineItem(lineItemId: string) {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    if (!formGroup || this.disabled) return;

    this.selectedLineItemId = lineItemId;
    this.dialog.open(ItemPostingsStationPopupComponent, {
      disableClose: true,
      width: '1200px',
      height: '620px',
      maxWidth: 'calc(100vw - 48px)',
      maxHeight: 'calc(100vh - 48px)',
      panelClass: 'station-range-dialog-panel',
      data: {
        form: formGroup,
      },
    });
  }

  openLocationPickerForLineItem(lineItemId: string) {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    if (!formGroup || this.disabled) return;

    this.selectedLineItemId = lineItemId;
    const existingLocation = {
      latitude: formGroup.controls?.latitude?.value,
      longitude: formGroup.controls?.longitude?.value,
      location: formGroup.controls?.location?.value,
    };

    if (this.hasCoordinateValue(existingLocation.latitude) && this.hasCoordinateValue(existingLocation.longitude)) {
      this.openLocationPickerDialog(existingLocation);
      return;
    }

    this.store.select(currentLocation)
      .subscribe(location => {
        let fallbackLocation = location || {};
        if (!this.hasCoordinateValue(fallbackLocation?.latitude) || !this.hasCoordinateValue(fallbackLocation?.longitude)) {
          this.store.select(siteDetails)
            .subscribe(site => {
              if (this.hasCoordinateValue(site?.latitude) && this.hasCoordinateValue(site?.longitude)) {
                fallbackLocation = { latitude: site.latitude, longitude: site.longitude };
              } else {
                this.store.select(projectDetails)
                  .subscribe(project => {
                    if (this.hasCoordinateValue(project?.latitude) && this.hasCoordinateValue(project?.longitude)) {
                      fallbackLocation = { latitude: project.latitude, longitude: project.longitude };
                    }
                  }).unsubscribe();
              }
            }).unsubscribe();
        }

        this.openLocationPickerDialog({
          ...fallbackLocation,
          location: existingLocation.location,
        });
      }).unsubscribe();
  }

  private openLocationPickerDialog(location: any) {
    // Captured now: the availability check is async, and the selection may move before the picker shows.
    const lineItemId = this.selectedLineItemId;
    const formGroup = this.getFormGroup(this.form, lineItemId);
    this.locationPickerLauncher.open({
      latitude: location?.latitude,
      longitude: location?.longitude,
      location: location?.location,
      enableLocationSection: true,
      showIncludeGpsLocationCheckbox: !!this.appData?.enableAashtoIntegration,
      locationText: location?.location || '',
      existingLink: formGroup?.get('map_feature_link')?.value ?? null,
      recordLabel: 'bid item',
    }).then(ref => {
      if (!ref) return; // another picker is already open; its pick is not ours
      this.pickTarget.hold(lineItemId, ref.afterClosed());
    }).catch(error => console.error('Location picker failed to open', error));
  }

  private buildStationRangeMapData(stationRange: any, locationPoint: any = null) {
    if (!stationRange) return null;

    const alignments = this.parsedAlignmentGeometry;
    if (!alignments.length) return null;

    const alignment = stationRange.alignment
      ? alignments.find(a => a.name === stationRange.alignment)
      : alignments[0];
    if (!alignment) return null;

    const selectedPath = this.getStationRangePolyline({
      alignment,
      fromStationName: stationRange.from?.station,
      toStationName: stationRange.to?.station,
    });
    if (selectedPath.length < 2) return null;

    const fromOffsetPoint = this.hasNonZeroOffset(stationRange.from)
      ? this.getOffsetStationPosition({
        alignment,
        stationName: stationRange.from?.station,
        offsetType: stationRange.from?.offsetType,
        offsetDistance: stationRange.from?.offsetDistance,
      })
      : null;
    const toOffsetPoint = this.hasNonZeroOffset(stationRange.to)
      ? this.getOffsetStationPosition({
        alignment,
        stationName: stationRange.to?.station,
        offsetType: stationRange.to?.offsetType,
        offsetDistance: stationRange.to?.offsetDistance,
      })
      : null;

    return {
      center: this.getMapCenter(selectedPath),
      geometry: this.buildLineStringFeatureCollection(alignment.polylineCoordinates, selectedPath, locationPoint, fromOffsetPoint, toOffsetPoint),
      selectedPath,
      endCapPaths: this.getStationRangeEndCapPaths(selectedPath[0], selectedPath[selectedPath.length - 1]),
      fromPosition: selectedPath[0],
      toPosition: selectedPath[selectedPath.length - 1],
      fromOffsetPoint,
      toOffsetPoint,
      fromLabel: stationRange.from?.station,
      toLabel: stationRange.to?.station,
      zoom: this.getStationRangeMapZoom(selectedPath),
    };
  }

  private hasNonZeroOffset(side: any) {
    const type = `${side?.offsetType || ''}`.toUpperCase();
    return (type.startsWith('RT') || type.startsWith('LT')) && Number(side?.offsetDistance) > 0;
  }

  private buildStationRangeFromValues(values: any) {
    if (!values) return null;
    return this.normalizeStationRange({
      alignment: values.alignment,
      from: {
        station: values.stationRangeFromStation,
        offsetType: values.stationRangeFromOffsetType,
        offsetDistance: values.stationRangeFromOffsetDistance,
      },
      to: {
        station: values.stationRangeToStation,
        offsetType: values.stationRangeToOffsetType,
        offsetDistance: values.stationRangeToOffsetDistance,
      },
    });
  }

  private normalizeStationRange(stationRange: any) {
    if (!stationRange) return null;

    const from = stationRange.from || {};
    const to = stationRange.to || {};
    const normalized = {
      alignment: stationRange.alignment || null,
      from: {
        station: from.station || null,
        offsetType: from.offsetType ?? from.offset_type ?? null,
        offsetDistance: from.offsetDistance ?? from.offset_distance ?? null,
      },
      to: {
        station: to.station || null,
        offsetType: to.offsetType ?? to.offset_type ?? null,
        offsetDistance: to.offsetDistance ?? to.offset_distance ?? null,
      },
    };

    const hasValue = [
      normalized.alignment,
      normalized.from.station,
      normalized.from.offsetType,
      normalized.from.offsetDistance,
      normalized.to.station,
      normalized.to.offsetType,
      normalized.to.offsetDistance,
    ].some(value => value !== null && value !== undefined && value !== '');

    return hasValue ? normalized : null;
  }

  private parseStationToFeet(stationName: string): number | null {
    const match = `${stationName || ''}`.match(/^(\d+)\+(\d+)$/);
    if (!match) return null;
    return parseInt(match[1], 10) * 100 + parseInt(match[2], 10);
  }

  private getOffsetDirectionMultiplier(offsetType: string) {
    if (`${offsetType || ''}`.startsWith('RT')) return -1;
    if (`${offsetType || ''}`.startsWith('LT')) return 1;
    return 0;
  }

  private getSignedOffsetFeet({ offsetType, offsetDistance }) {
    const distance = parseFloat(offsetDistance);
    return this.getOffsetDirectionMultiplier(offsetType) * (Number.isFinite(distance) ? distance : 0);
  }

  private getDistanceBetweenCoordinatesFeet(start: any, end: any) {
    if (!start || !end) return 0;
    const earthRadiusFeet = 20902231;
    const toRad = deg => (deg * Math.PI) / 180;
    const latitude = (start.lat + end.lat) / 2;
    const cosLat = Math.max(Math.cos(toRad(latitude)), 0.000001);
    const dx = toRad(end.lng - start.lng) * earthRadiusFeet * cosLat;
    const dy = toRad(end.lat - start.lat) * earthRadiusFeet;
    return Math.sqrt(dx * dx + dy * dy);
  }

  private getOffsetCoordinate({ coordinate, previousCoordinate, nextCoordinate, offsetFeet }) {
    if (!coordinate || !offsetFeet) return coordinate;
    const tangentStart = previousCoordinate || coordinate;
    const tangentEnd = nextCoordinate || coordinate;
    const earthRadiusFeet = 20902231;
    const toRad = deg => (deg * Math.PI) / 180;
    const toDeg = rad => (rad * 180) / Math.PI;
    const cosLat = Math.max(Math.cos(toRad(coordinate.lat)), 0.000001);
    const dx = toRad(tangentEnd.lng - tangentStart.lng) * earthRadiusFeet * cosLat;
    const dy = toRad(tangentEnd.lat - tangentStart.lat) * earthRadiusFeet;
    const length = Math.sqrt(dx * dx + dy * dy);
    if (!length) return coordinate;

    const leftNormalX = -dy / length;
    const leftNormalY = dx / length;
    const offsetX = leftNormalX * offsetFeet;
    const offsetY = leftNormalY * offsetFeet;

    return {
      lat: coordinate.lat + toDeg(offsetY / earthRadiusFeet),
      lng: coordinate.lng + toDeg(offsetX / (earthRadiusFeet * cosLat)),
    };
  }

  private getOffsetStationRangePolyline({
    polyline,
    fromOffsetType,
    fromOffsetDistance,
    toOffsetType,
    toOffsetDistance,
  }) {
    if (!polyline?.length || polyline.length < 2) return polyline || [];

    const fromOffsetFeet = this.getSignedOffsetFeet({ offsetType: fromOffsetType, offsetDistance: fromOffsetDistance });
    const toOffsetFeet = this.getSignedOffsetFeet({ offsetType: toOffsetType, offsetDistance: toOffsetDistance });
    if (!fromOffsetFeet && !toOffsetFeet) return polyline;

    const segmentLengths = polyline
      .slice(0, -1)
      .map((coordinate, index) => this.getDistanceBetweenCoordinatesFeet(coordinate, polyline[index + 1]));
    const totalLength = segmentLengths.reduce((sum, length) => sum + length, 0);
    let cumulativeLength = 0;

    return polyline.map((coordinate, index) => {
      if (index > 0) {
        cumulativeLength += segmentLengths[index - 1] || 0;
      }

      const progress = totalLength ? cumulativeLength / totalLength : 0;
      const offsetFeet = fromOffsetFeet + (toOffsetFeet - fromOffsetFeet) * progress;
      return this.getOffsetCoordinate({
        coordinate,
        previousCoordinate: polyline[index - 1],
        nextCoordinate: polyline[index + 1],
        offsetFeet,
      });
    });
  }

  private getStationPositionOnAlignment({ alignment, stationName }) {
    const stationFeet = this.parseStationToFeet(stationName);
    const stations = alignment?.stations || [];
    if (stationFeet == null || stations.length < 2) return null;

    for (let index = 0; index < stations.length - 1; index++) {
      const segmentStartFeet = this.parseStationToFeet(stations[index].name);
      const segmentEndFeet = this.parseStationToFeet(stations[index + 1].name);
      const segmentStart = stations[index].coordinate;
      const segmentEnd = stations[index + 1].coordinate;

      if (segmentStartFeet == null || segmentEndFeet == null || !segmentStart || !segmentEnd) {
        continue;
      }

      const segmentLow = Math.min(segmentStartFeet, segmentEndFeet);
      const segmentHigh = Math.max(segmentStartFeet, segmentEndFeet);
      if (stationFeet < segmentLow || stationFeet > segmentHigh) {
        continue;
      }

      const ratio = segmentEndFeet === segmentStartFeet
        ? 0
        : (stationFeet - segmentStartFeet) / (segmentEndFeet - segmentStartFeet);

      return {
        coordinate: {
          lat: segmentStart.lat + ratio * (segmentEnd.lat - segmentStart.lat),
          lng: segmentStart.lng + ratio * (segmentEnd.lng - segmentStart.lng),
        },
        previousCoordinate: segmentStart,
        nextCoordinate: segmentEnd,
      };
    }

    return null;
  }

  private getOffsetStationPosition({ alignment, stationName, offsetType, offsetDistance }) {
    const stationPosition = this.getStationPositionOnAlignment({ alignment, stationName });
    if (!stationPosition) return null;

    return this.getOffsetCoordinate({
      coordinate: stationPosition.coordinate,
      previousCoordinate: stationPosition.previousCoordinate,
      nextCoordinate: stationPosition.nextCoordinate,
      offsetFeet: this.getSignedOffsetFeet({ offsetType, offsetDistance }),
    });
  }

  private makeCoordinate(coordinate: any) {
    if (!coordinate) return null;
    if (Array.isArray(coordinate) && coordinate.length >= 2) {
      return { lat: Number(coordinate[1]), lng: Number(coordinate[0]) };
    }
    const lat = Number(coordinate.lat ?? coordinate.latitude);
    const lng = Number(coordinate.lng ?? coordinate.longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return { lat, lng };
    }
    return null;
  }

  private parseAlignmentGeometry(alignmentGeometry: any) {
    try {
      const geojson = typeof alignmentGeometry === 'string'
        ? JSON.parse(alignmentGeometry)
        : alignmentGeometry;
      if (!geojson?.features?.length) return [];

      return geojson.features.map(feature => {
        const coordinates = feature?.geometry?.coordinates || [];
        const rawStations = feature?.properties?.stations || [];
        const stations = rawStations.map((station, index) => {
          const coordinate = this.makeCoordinate(coordinates[index]);
          return coordinate ? { name: station?.name, coordinate } : null;
        }).filter(Boolean);

        return {
          name: feature?.properties?.name || '',
          polylineCoordinates: coordinates.map(coordinate => this.makeCoordinate(coordinate)).filter(Boolean),
          stations,
        };
      });
    } catch {
      return [];
    }
  }

  private getStationRangePolyline({ alignment, fromStationName, toStationName }) {
    const fromFeet = this.parseStationToFeet(fromStationName);
    const toFeet = this.parseStationToFeet(toStationName);
    const stations = alignment?.stations || [];

    if (fromFeet == null || toFeet == null || stations.length < 2 || !alignment?.polylineCoordinates?.length) {
      return [];
    }

    const rangeStart = Math.min(fromFeet, toFeet);
    const rangeEnd = Math.max(fromFeet, toFeet);
    const points = [];

    for (let index = 0; index < stations.length - 1; index++) {
      const segmentStartFeet = this.parseStationToFeet(stations[index].name);
      const segmentEndFeet = this.parseStationToFeet(stations[index + 1].name);
      const segmentStart = stations[index].coordinate;
      const segmentEnd = stations[index + 1].coordinate;

      if (segmentStartFeet == null || segmentEndFeet == null || !segmentStart || !segmentEnd) {
        continue;
      }

      const segmentLow = Math.min(segmentStartFeet, segmentEndFeet);
      const segmentHigh = Math.max(segmentStartFeet, segmentEndFeet);
      const overlapStart = Math.max(rangeStart, segmentLow);
      const overlapEnd = Math.min(rangeEnd, segmentHigh);

      if (overlapStart > overlapEnd) {
        continue;
      }

      const coordinateForFeet = feet => {
        const ratio = segmentEndFeet === segmentStartFeet
          ? 0
          : (feet - segmentStartFeet) / (segmentEndFeet - segmentStartFeet);
        return {
          lat: segmentStart.lat + ratio * (segmentEnd.lat - segmentStart.lat),
          lng: segmentStart.lng + ratio * (segmentEnd.lng - segmentStart.lng),
        };
      };

      const startCoordinate = coordinateForFeet(overlapStart);
      const endCoordinate = coordinateForFeet(overlapEnd);
      const lastPoint = points[points.length - 1];

      if (!lastPoint || lastPoint.lat !== startCoordinate.lat || lastPoint.lng !== startCoordinate.lng) {
        points.push(startCoordinate);
      }
      points.push(endCoordinate);
    }

    return points;
  }

  private getMapCenter(points: any[]) {
    const totals = points.reduce((acc, point) => ({
      lat: acc.lat + point.lat,
      lng: acc.lng + point.lng,
    }), { lat: 0, lng: 0 });

    return {
      lat: totals.lat / points.length,
      lng: totals.lng / points.length,
    };
  }

  private getStationRangeMapZoom(points: any[]) {
    const bounds = points.reduce((acc, point) => ({
      minLat: Math.min(acc.minLat, point.lat),
      maxLat: Math.max(acc.maxLat, point.lat),
      minLng: Math.min(acc.minLng, point.lng),
      maxLng: Math.max(acc.maxLng, point.lng),
    }), {
      minLat: points[0].lat,
      maxLat: points[0].lat,
      minLng: points[0].lng,
      maxLng: points[0].lng,
    });
    const span = Math.max(bounds.maxLat - bounds.minLat, bounds.maxLng - bounds.minLng);

    if (span < 0.0003) return 19;
    if (span < 0.0008) return 18;
    return 17;
  }

  private getStationRangeEndCapPaths(start: any, end: any) {
    if (!start || !end) return [];

    const latDelta = end.lat - start.lat;
    const lngDelta = end.lng - start.lng;
    const length = Math.sqrt(latDelta * latDelta + lngDelta * lngDelta);
    if (!length) return [];

    const perpendicularLat = -lngDelta / length;
    const perpendicularLng = latDelta / length;
    const capLength = Math.max(length * 0.16, 0.000055);
    const halfCapLength = capLength / 2;

    const capForPoint = point => [
      {
        lat: point.lat - perpendicularLat * halfCapLength,
        lng: point.lng - perpendicularLng * halfCapLength,
      },
      {
        lat: point.lat + perpendicularLat * halfCapLength,
        lng: point.lng + perpendicularLng * halfCapLength,
      },
    ];

    return [capForPoint(start), capForPoint(end)];
  }

  private buildLineStringFeatureCollection(
    alignmentPath: any[],
    selectedPath: any[] = [],
    locationPoint: any = null,
    fromOffsetPoint: any = null,
    toOffsetPoint: any = null,
  ) {
    const features = [];
    if (alignmentPath?.length >= 2) {
      features.push({
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: alignmentPath.map(point => [point.lng, point.lat]),
          color: selectedPath?.length >= 2 ? '#8EA0D8' : '#1036D6',
          opacity: selectedPath?.length >= 2 ? 0.55 : 1,
          strokeWidth: selectedPath?.length >= 2 ? 2 : 3,
          includeInExtent: selectedPath?.length < 2,
        },
      });
    }

    if (selectedPath?.length >= 2) {
      // Card mini-map: dashed range + book-end ticks only (mobile parity).
      // No offset dots/ties. Coarser dash + thinner stroke so it reads as
      // dashed at the small card zoom instead of looking solid.
      features.push({
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'LineString',
          coordinates: selectedPath.map(point => [point.lng, point.lat]),
          color: '#1036D6',
          dashTemplate: [12, 9],
          strokeWidth: 3,
        },
      });

      this.getStationRangeEndCapPaths(selectedPath[0], selectedPath[selectedPath.length - 1]).forEach(capPath => {
        features.push({
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: capPath.map(point => [point.lng, point.lat]),
            color: '#1036D6',
            strokeWidth: 3,
          },
        });
      });
    }

    if (locationPoint) {
      features.push({
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [locationPoint.lng, locationPoint.lat],
          color: '#1036D6',
          markerIconUrl: '/assets/icons/map/markers/location-pin.svg',
          iconSize: { width: 14, height: 19, yOffset: 9.5 },
          includeInExtent: true,
        },
      });
    }

    return {
      type: 'FeatureCollection',
      features,
    };
  }

  getSelectedLineItemPictures() {
    const pictures = this.getFormGroup(this.form, this.selectedLineItemId)?.get('pictures')?.value || '[]';
    this.selectedLineItem = this.lineItems?.find(item => item.id === this.selectedLineItemId);
    return JSON.parse(pictures);
  }

  getSelectedLineItemVideos() {
    const videos = this.getFormGroup(this.form, this.selectedLineItemId)?.get('videos')?.value || '[]';
    return JSON.parse(videos);
  }

  addNewLineItem(newElement) {
    this.lineItems.push(newElement);
    // Rebuilt from the old values, keeping a link removed on another line removed (R54)
    this.form = rebuildKeepingLinkRemovals(this.form, () => this.createLineItemForm(this.bidItem, this.lineItems));

    this.calculateLineItemQuantity();


    this.formSubscription = this.form.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.calculateLineItemQuantity();


      });
    this.selectedLineItemMediaFiles = [];


    if (this.disabled) {
      this.form.disable();
      this.projectsService.isAnyFormDirty.next(false);
    }
  }

  deleteLineItem(lineItemId) {
    this.form.removeControl(lineItemId);
    this.projectsService.isAnyFormDirty.next(true);
    this.lineItems = this.lineItems.filter(o => o.id !== lineItemId);

    if (this.selectedLineItemId === lineItemId) {
      this.selectedLineItemId = null;
    }
  }

  deletePicture(pic) {
    if (pic.fileType === 'picture') {
      let pictures = this.getSelectedLineItemPictures();

      pictures = pictures?.filter(o => o.id !== pic.id);
      this.selectedLineItemMediaFiles = this.selectedLineItemMediaFiles?.filter(o => o.id !== pic.id);
      this.getFormGroup(this.form, this.selectedLineItemId)?.get('pictures').setValue(JSON.stringify(pictures));
    }

    if (pic.fileType === 'video') {
      let videos = this.getSelectedLineItemVideos();

      videos = videos?.filter(o => o.id !== pic.id);
      this.selectedLineItemMediaFiles = this.selectedLineItemMediaFiles?.filter(o => o.id !== pic.id);
      this.getFormGroup(this.form, this.selectedLineItemId)?.get('videos').setValue(JSON.stringify(videos));
      this.videoToBeDeletedFromMuxDb.push(pic.id);
    }
  }

  /**
   * W77 (review M5): one rule for every Clear: the app's confirm only when markup would go with the link (held strokes,
   * the record's sheet markup, a marked-up capture); otherwise the line clears at once, as every other record does.
   */
  deleteLocation(lineItemId) {
    const link = this.getFormGroup(this.form, lineItemId)?.get('map_feature_link')?.value ?? null;
    dropLinkWithConfirm(this.dialog, this.injector, link, () => this.clearLocation(lineItemId));
  }

  private clearLocation(lineItemId) {
    // A pinless line never keeps a link: the helper clears map_feature_link with the pin.
    clearLocationControls(this.getFormGroup(this.form, lineItemId), [
      'alignment',
      'stationRangeFromStation', 'stationRangeFromOffsetType', 'stationRangeFromOffsetDistance',
      'stationRangeToStation', 'stationRangeToOffsetType', 'stationRangeToOffsetDistance',
    ]);
    this.updateStationRangeDisplayCache();
    this.publishLocationStationToolbarState(lineItemId);
  }

  removeDesignContext(lineItemId: string): void {
    if (this.disabled) return;
    const formGroup = this.getFormGroup(this.form, lineItemId);
    removeLinkControl(formGroup);
    formGroup?.markAsDirty();
    this.updateStationRangeDisplayCache();
  }

  /** The control's server-side updates (retry, finished render, saved markup): not an unsaved edit, so no valueChanges. */
  setDesignContext(lineItemId: string, link: MapFeatureLink): void {
    this.getFormGroup(this.form, lineItemId)?.get('map_feature_link')?.setValue(link, { emitEvent: false });
    this.updateStationRangeDisplayCache();
  }

  showLocationSection(lineItemId) {
    return this.getFormGroup(this.form, lineItemId)?.controls?.latitude?.value !== null &&
      this.getFormGroup(this.form, lineItemId)?.controls?.longitude?.value !== null &&
      this.getFormGroup(this.form, lineItemId)?.controls?.latitude?.value !== '' &&
      this.getFormGroup(this.form, lineItemId)?.controls?.longitude?.value !== '';
  }

  createAvatar(name) {
    return name.split('')[0];
  }

  /**
   * Format date with lowercase am/pm
   */
  formatDateWithLowerAmPm(date: string | Date): string {
    if (!date) return '';
    return moment(date).format('MMMM DD, YYYY, hh:mm a').replace(/AM|PM/g, match => match.toLowerCase());
  }

  getCleanFormValues(form) {
    const lineItemValues = JSON.parse(JSON.stringify(form.getRawValue() || {}));

    Object.keys(lineItemValues).forEach(key => {
      // Check if the key contains an underscore
      if (key.includes('_')) {
        // Extract the part before the underscore
        const baseKey = key.split('_')[0];

        // If the base key exists in the object, delete the one without the underscore
        if (lineItemValues[baseKey] !== undefined) {
          delete lineItemValues[baseKey];
        }
      }
    });

    return lineItemValues;
  }

  getGpsMeasurements(lineItem: any): any[] {
    if (!lineItem?.geometry?.features?.length) return [];
    return lineItem.geometry.features
      .filter(f => f.properties?.source?.measurements || f.properties?.modified_fields)
      .map(f => ({
        measurements: f.properties?.source?.measurements || {},
        modified_fields: f.properties?.modified_fields || {},
        meta: f.properties?.source?.meta || {},
      }));
  }

  // The overview map shows every entry's shapes together; each entry has its own mini map.
  // Memoized on the entries' geometry objects so the map input keeps one reference between change
  // detections, and rebuilds when an entry is added, removed or gets new geometry.
  private allEntriesMapCache: { geometries: any[]; geometry: any; sources: { lineItem: any; index: number }[] } = null;

  get allEntriesMapGeometry(): any {
    const geometries = (this.lineItems || []).map(li => li?.geometry);
    const cached = this.allEntriesMapCache?.geometries;
    if (!cached || cached.length !== geometries.length || cached.some((g, i) => g !== geometries[i])) {
      const features = [];
      const sources = [];
      (this.lineItems || []).filter(li => this.hasGpsGeometry(li)).forEach(li => {
        li.geometry.features.forEach((feature, index) => {
          features.push(feature);
          sources.push({ lineItem: li, index });
        });
      });
      this.allEntriesMapCache = {
        geometries,
        geometry: features.length ? { type: 'FeatureCollection', features } : null,
        sources,
      };
    }
    return this.allEntriesMapCache.geometry;
  }

  openAllEntriesVolume3d(featureIndex: number): void {
    const source = this.allEntriesMapCache?.sources[featureIndex];
    if (source) {
      this.openVolume3d(source.lineItem, this.getGpsFeatures(source.lineItem).indexOf(source.lineItem.geometry.features[source.index]));
    }
  }

  hasGpsGeometry(lineItem: any): boolean {
    if (lineItem?.id && this.cachedGpsFlags.has(lineItem.id)) {
      return this.cachedGpsFlags.get(lineItem.id);
    }
    return BidService.hasGpsGeometry(lineItem) && !lineItem?.sources?.length;
  }

  getGpsFeatures(lineItem: any): any[] {
    if (lineItem?.id && this.cachedGpsFeatures.has(lineItem.id)) {
      return this.cachedGpsFeatures.get(lineItem.id);
    }
    return BidService.getGpsFeatures(lineItem);
  }

  private refreshGpsCaches(): void {
    this.cachedGpsFlags.clear();
    this.cachedGpsFeatures.clear();
    this.lineItems?.forEach(li => {
      if (li?.id) {
        const isGps = BidService.hasGpsGeometry(li) && !li?.sources?.length;
        this.cachedGpsFlags.set(li.id, isGps);
        if (isGps) {
          this.cachedGpsFeatures.set(li.id, BidService.getGpsFeatures(li));
        }
      }
    });
  }

  featureHasQuantityMapping(feature: any): boolean {
    return BidService.featureHasQuantityMapping(feature);
  }

  private getInitialGpsQuantityMode(feature: any): string {
    return BidService.getInitialGpsQuantityMode(feature);
  }

  calculateGpsMeasuredQty(feature: any): number {
    return BidService.calculateGpsMeasuredQty(feature);
  }

  private calculateGpsAutoQty(feature: any): number {
    return BidService.calculateGpsAutoQty(feature, this.bidItem);
  }

  getGpsQuantityForMode(feature: any, mode: string): number {
    return BidService.calculateGpsFeatureQuantity(feature, mode, this.bidItem);
  }

  getGpsMode(lineItemId: string, featureIndex: number): string {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    return formGroup?.get(`gpsQuantityMode_${featureIndex}`)?.value || '';
  }

  getGpsDisplayQuantity(lineItemId: string, featureIndex: number): number {
    const formGroup = this.getFormGroup(this.form, lineItemId);
    const mode = this.getGpsMode(lineItemId, featureIndex);

    if (mode === 'auto') {
      // Auto mode - read from form's calculated value (set by calculateQuantity)
      const lineItem = this.lineItems.find(li => li.id === lineItemId);
      const features = this.getGpsFeatures(lineItem);
      if (features.length > 1) {
        return Number(formGroup?.get(`gpsQuantity_${featureIndex}`)?.value) || 0;
      }
      return Number(formGroup?.get('quantity')?.value) || 0;
    }

    // Measured mode - use GPS measurement value
    const lineItem = this.lineItems.find(li => li.id === lineItemId);
    const features = this.getGpsFeatures(lineItem);
    return this.getGpsQuantityForMode(features[featureIndex], mode);
  }

  getGpsMeasuredQtyHint(lineItemId: string, featureIndex: number): string {
    const lineItem = this.lineItems.find(li => li.id === lineItemId);
    const features = this.getGpsFeatures(lineItem);
    const qty = this.calculateGpsMeasuredQty(features[featureIndex]);
    return `Measured quantity: ${qty}`;
  }

  private updateGpsModifiedFields(lineItemId: string, featureIndex: number, updates: { [key: string]: any }): void {
    const lineItem = this.lineItems.find(li => li.id === lineItemId);
    if (!lineItem?.geometry?.features?.[featureIndex]) return;

    const feature = lineItem.geometry.features[featureIndex];
    if (!feature.properties) feature.properties = {};
    if (!feature.properties.modified_fields) feature.properties.modified_fields = {};

    Object.assign(feature.properties.modified_fields, updates);
  }

  private handleGpsQuantityModeChange(controlName: string, features: any[], feature: any, index: number, mode: string): void {
    const formGroup = this.getFormGroup(this.form, controlName);
    let qty = 0;

    if (mode === 'auto' && this.bidItem.rollup) {
      // Auto mode - use GPS feature's modified_fields (consistent with calculateQuantity)
      qty = BidService.calculateGpsAutoQty(feature, this.bidItem);
    } else if (mode === 'measured') {
      qty = this.getGpsQuantityForMode(feature, mode);
    } else {
      qty = null; // Manual mode - clear for user input
    }

    if (features.length > 1) {
      formGroup.get(`gpsQuantity_${index}`)?.setValue(qty, { emitEvent: false });
    } else {
      formGroup.get('quantity')?.setValue(qty, { emitEvent: false });
    }

    // Persist mode and quantity to geometry modified_fields
    this.updateGpsModifiedFields(controlName, index, {
      quantityMode: mode,
      quantity: qty ?? 0,
    });

    if (features.length > 1) {
      this.recalculateGpsTotalQuantity(controlName, features);
    } else {
      this.lineItemTotals[controlName] = Number(qty) || 0;
      this.calculateTotalQuantity();
    }

    if (this.editable) {
      this.projectsService.isAnyFormDirty.next(true);
    }
  }

  private recalculateGpsTotalQuantity(controlName: string, features: any[]): void {
    const formGroup = this.getFormGroup(this.form, controlName);
    let total = 0;
    features.forEach((_, i) => {
      total += Number(formGroup.get(`gpsQuantity_${i}`)?.value) || 0;
    });
    formGroup.get('quantity')?.setValue(total, { emitEvent: false });
    this.lineItemTotals[controlName] = total;
    this.calculateTotalQuantity();
  }

  /**
   * Handle line item hover for map highlight effect
   */
  /**
   * Returns true for the accordion that should be visually highlighted.
   * If any item is being hovered, only that one highlights.
   * Otherwise the currently-expanded item highlights.
   */
  isActiveLineItem(lineItemId: string): boolean {
    if (!this.mapMode) return false;
    if (this.hoveredLineItemId) return this.hoveredLineItemId === lineItemId;
    return this.selectedLineItemId === lineItemId;
  }

  onLineItemHover(lineItemId: string): void {
    this.mapService.hoveredLineItemId.next(lineItemId);
  }

  /**
   * Handle line item hover end to reset map highlight
   */
  onLineItemHoverEnd(): void {
    this.mapService.hoveredLineItemId.next(null);
  }

  /**
   * Handle GPS feature hover for per-feature map highlight
   */
  onGpsFeatureHover(lineItemId: string, featureIndex: number): void {
    this.hoveredGpsFeatureKey = `${lineItemId}_${featureIndex}`;
    // Set line item ID first so hoveredGpsFeatureIndex subscriber can read it via getValue()
    this.mapService.hoveredLineItemId.next(lineItemId);
    this.mapService.hoveredGpsFeatureIndex.next(featureIndex);
  }

  /**
   * Handle GPS feature hover end
   */
  onGpsFeatureHoverEnd(): void {
    this.hoveredGpsFeatureKey = null;
    // Clear feature index first, then line item ID
    this.mapService.hoveredGpsFeatureIndex.next(null);
    this.mapService.hoveredLineItemId.next(null);
  }

  /**
   * Handle click-to-select on a GPS feature section (toggle selection)
   */
  onGpsFeatureClick(lineItemId: string, featureIndex: number): void {
    const key = `${lineItemId}_${featureIndex}`;
    if (this.selectedGpsFeatureKey === key) {
      // Deselect
      this.clearGpsFeatureSelection();
    } else {
      // Select
      this.selectedGpsFeatureKey = key;
      this.mapService.selectedGpsLineItemId.next(lineItemId);
      this.mapService.selectedGpsFeatureIndex.next(featureIndex);
    }
  }

  /**
   * Clear GPS feature selection
   */
  clearGpsFeatureSelection(): void {
    this.selectedGpsFeatureKey = null;
    this.mapService.selectedGpsLineItemId.next(null);
    this.mapService.selectedGpsFeatureIndex.next(null);
  }

  /** "Volume" for mobile volume captures, otherwise the raw GeoJSON type. */
  featureTypeLabel(feature: any): string {
    return isVolumeFeature(feature) ? 'Volume' : (feature?.geometry?.type || '');
  }

  isVolume(feature: any): boolean {
    return isVolumeFeature(feature);
  }

  volumeLabel(feature: any): string {
    return formatVolumeLabel(feature, this.bidItem);
  }

  volumePoints(feature: any): number {
    return feature?.properties?.source?.measurements?.num_points ?? feature?.geometry?.coordinates?.length ?? 0;
  }

  /** Open the 3D viewer for one volume feature. Stops propagation so the row's select toggle doesn't fire. */
  openVolume3d(lineItem: any, featureIndex: number, event?: Event): void {
    event?.stopPropagation();
    const feature = this.getGpsFeatures(lineItem)[featureIndex];
    if (!feature?.geometry?.coordinates) return;
    VolumeViewerDialogComponent.open(this.dialog, {
      coordinates: feature.geometry.coordinates,
      label: this.volumeLabel(feature),
      title: [this.bidItem?.item, this.bidItem?.description].filter(Boolean).join(' '),
    });
  }

  /**
   * Format GPS accuracy using hrms (horizontal RMS) when available, falling back to accuracy.
   * Shows in cm when < 1m for better precision display.
   */
  formatGpsAccuracy(meta: any): string {
    const value = meta?.hrms ?? meta?.accuracy;
    if (value == null) return '';
    if (value < 1) {
      return `${(value * 100).toFixed(1)}cm`;
    }
    return `${value.toFixed(2)}m`;
  }

  private getSiteQuantity(): any {
    const siteId = this.dailyReport?.site_id;
    return siteId && this.siteQuantities?.find(sq => sq.site_id === siteId);
  }

  getCapacity(): number | null {
    if (!this.bidItem) return null;
    const siteQty = this.getSiteQuantity();
    const total = siteQty ? siteQty.quantity : this.bidItem.quantity;
    return total != null ? Number(total) : null;
  }

  getConsumed(): number {
    const siteQty = this.getSiteQuantity();
    const serverConsumed = Number(siteQty ? siteQty.consumed : this.bidItem?.consumed) || 0;
    const currentOffset = (Number(this.quantityTotal) || 0) - this.savedQuantityTotal;
    return serverConsumed + currentOffset;
  }

  getRemaining(): number {
    return (this.getCapacity() ?? 0) - this.getConsumed();
  }

  getOverLimit(): number {
    return Math.abs(Math.min(0, this.getRemaining()));
  }

  ngOnDestroy() {
    if (this.mapMode && this.selectedLineItemId && this.mapService.openLineItemId.getValue() === this.selectedLineItemId) {
      this.mapService.openLineItemId.next(null);
    }
    this.formSubscriptions.map(o => o?.unsubscribe());
    this.formSubscriptions = [];
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
